<div class="px-3 py-5 feedback_card rounded-md mt-2 w-full">
  <main-dynamic-form
    (submit)="submitForm($event)"
    [fields]="fields"
    [form]="form"
    [loading]="saveLoading"
    (fieldData)="getSelected($event)"
    [showRequiredTitle]="false"
    class="py-5"
    loadingMessage="Operation in progress, please wait..."
  ></main-dynamic-form>
</div>
